/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import { connect } from 'react-redux';
import { Switch, Route, withRouter, Redirect, Link } from 'react-router-dom';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import _ from 'lodash';
import PropTypes from 'prop-types';
// import BussEstSettingsContainer from './businessEstablishments/container/BussEstSettingsContainer';
// import FeesContainer from './fees/container/FeesContainer';
import Requirements from './requirements/container/RequirementsTagging';
import RequirementsTaggingBorongan from './requirements/container/RequirementsTaggingBorongan';

function SettingsContainer({ match, pathName, permissions }) {
  return (
    <React.Fragment>
      <div className="card-content-listing">
        <div className="container-fluid mb-4">
          <div className="row">
            <ul className="nav nav-tabs btn-settings-tab-container">
              {/* <li className="nav-item">
                <Link
                  to="/ohp/settings/business-establishment"
                  className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                    pathName.indexOf('ohp/settings/business-establishment') > -1
                      ? 'selected'
                      : ''
                    }`}
                >
                  Business Establishment
                </Link>
              </li>

              <li className="nav-item">
                <Link
                  to="/ohp/settings/fees"
                  className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                    pathName.indexOf('ohp/settings/fees') > -1 ? 'selected' : ''
                    }`}
                >
                  Fees
                </Link>
              </li> */}
              <li className="nav-item">
                <Link
                  to="/real-property-tax/settings/requirements"
                  className={`nav-link btn-settings-tab py-3 px-5 font-weight-bold h2 ${
                    pathName.indexOf('/real-property-tax/settings/requirements') > -1 ? 'selected' : ''
                  }`}
                >
                  Requirements
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <Switch>
          <Route
            exact
            path={`${match.path}`}
            render={() => (
              <Redirect to={`${match.path}/requirements`} />
            )}
          />
          {/* <Route
            path={`${match.path}/business-establishment`}
            component={BussEstSettingsContainer}
          />
          <Route path={`${match.path}/fees`} component={FeesContainer} /> */}
          {/* <Route path={`${match.path}/requirements`} component={Requirements} /> */}
          {Acl(permissions, ['VIEW REQUIREMENTS TAGGING BORONGAN']) ? 
            <Route path={`${match.path}/requirements`} component={RequirementsTaggingBorongan} /> : 
            <Route path={`${match.path}/requirements`} component={Requirements} />}
        </Switch>
      </div>
    </React.Fragment>
  );
}

SettingsContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  pathName: PropTypes.string.isRequired,
  permissions: PropTypes.instanceOf(Object).isRequired
};

const mapStateToProps = ({ api }, { match, location }) => ({
  mainModule: _.get(match, 'params.mainModule'),
  pathName: _.get(location, 'pathname'),
  profile: _.get(api, 'AUTH/user_profile.item') || {},
  permissions: getJson('permissions'),
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(SettingsContainer);
